







































































































import { Component, Vue } from 'vue-property-decorator';
import { changeLoading } from '@/util/plugins';
const getUrl = require('baimahu/url-with-param');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  set_meal_list: `${FCAPI}/shang/ruan/suit`,
  change_status: `${FCAPI}/shang/ruan/suit/onlinestatus/`,
  change_sort: `${FCAPI}/shang/ruan/suit/sort/`,
};
const dateFormat = require('bmh/date-format');
function initSetMealList(remote?: any) {
  remote = remote || {};
  return {
    current: remote.current || 0,
    detail: remote.detail || [],
    last: remote.last || 0,
    limit: remote.limit || 0,
    total: remote.total || 0,
  };
}
const STATUS = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '上架中',
  },
  {
    value: 5,
    label: '已下架',
  },
];
@Component
export default class RuanSetMeal extends Vue {
  active_index: number = -1;
  is_loading: boolean = false;
  name: string = '';
  set_meal_status: number = 0;
  set_meal_list: any = initSetMealList();
  old_value: string = '';
  get status() {
    return STATUS;
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  paginationOption(data: any) {
    return {
      showTotal: () => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 0,
      total: data.total || 0,
      current: data.current || 0,
    };
  }

  // 跳转新增套餐页面
  addSetMeal() {
    this.$router.push('/operation/add-set-meal');
  }

  // 清空搜索条件
  clearForm() {
    this.name = '';
    this.set_meal_status = 0;
  }

  // 切换分页
  @changeLoading(['is_loading'])
  async handleChange(data: any) {
    await this.getSetMealList({
      current: data.current,
      name: this.name,
      online_status: this.set_meal_status,
    });
  }

  // 切换上下架状态
  @changeLoading(['is_loading'])
  async changeStatus(record: any) {
    const res = await this.$axios.put(`${API.change_status}${record.id}`, {
      id: record.id,
      online_status: record.online_status === 1 ? 5 : 1,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    await this.getSetMealList();
  }

  // 点击搜索按钮
  @changeLoading(['is_loading'])
  async clickSearchBtn() {
    await this.getSetMealList({
      current: 1,
      name: this.name,
      online_status: this.set_meal_status,
    });
  }

  // 查询软装套餐列表
  @changeLoading(['is_loading'])
  async getSetMealList(
    query_params: any = {
      current: 1,
    }
  ) {
    this.set_meal_list = initSetMealList();
    const url = getUrl(API.set_meal_list, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.set_meal_list = initSetMealList(res.data.data);
  }

  // 展示修改排序输入框
  showInput(index: number, record: any) {
    this.active_index = index;
    this.old_value = record.sort;
  }

  // 关闭修改排序输入框
  closeInput(record: any) {
    this.active_index = -1;
    record.sort = this.old_value;
    this.old_value = '';
  }

  // 跳转到编辑页面
  editSetMeal(record: any) {
    this.$router.push(`/operation/add-set-meal?id=${record.id}`);
  }

  // 更改排序值
  @changeLoading(['is_loading'])
  async changeSort(record: any) {
    const res = await this.$axios.put(`${API.change_sort}${record.id}`, {
      id: record.id,
      sort: record.sort,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.active_index = -1;
    await this.getSetMealList();
  }

  @changeLoading(['is_loading'])
  async created() {
    await this.getSetMealList();
  }
}
